import React from 'react'
import SignUp from '../../Components/SignUp/SignUp'
import styles from '../../Components/SignUp/SignUp.module.css';  // Import CSS Module styles
import { useTranslation } from "react-i18next";

 function SignUpPage() {
    const { t, i18n } = useTranslation();
  
  return (
    <div className='flex-grow-1'>
    <div className={styles.loginContainer}>
    <div className={styles.loginHeader}>{t("signUp")}</div>

      </div>
      <SignUp />
    </div>
  )
}
export default SignUpPage
